/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

// Inspirováno vzorovým zpracováním
// - https://vuejs.org/v2/guide/custom-directive.html#simplest-directive-example
export default {
  inserted(el, binding) {
    if (isNil(binding.value) || binding.value) {
      el.focus();
    }
  }
};
